function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24.99c6.63 0 12-5.37 12-12s-5.37-12-12-12-12 5.37-12 12 5.37 12 12 12z",
  fill: "#3350BC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.92 13.44h-1.53v-.68h1.5v-1.22h-1.5V8.3h-3.15v5.96c0 1.29-.59 2.04-.79 2.05v1.22c1.11 0 2.01-1.47 2.01-3.27V9.52h.71v4.68c0 2.42-1.36 4-3.61 4.24V16.7h-.61c-1.09 0-2.25-.24-2.25-3.13V8.3H6.66v3.24H5.08v1.22h1.58v.68H5.11v1.22h1.56c.07 3.46 2.77 4.86 3.9 4.86V18.3c-.57 0-2.69-.94-2.69-3.77V9.51h.61v4.05c0 2.66.94 4.08 2.86 4.32v1.81h.61c3.1 0 5.22-2 5.42-5.03h1.54v-1.22z",
  fill: "#fff"
});

function SvgUntb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "b88d14037769dca34ae6614c10616f12.svg";
export { SvgUntb as ReactComponent };